"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _rumEvent = require("../types/rum-event");
var _client = _interopRequireDefault(require("../model/client"));
var _is = require("../utils/is");
var _combineConfig = _interopRequireWildcard(require("../utils/combineConfig"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Shell = exports["default"] = /*#__PURE__*/function () {
  function Shell(config) {
    this.client = void 0;
    this.client = new _client["default"]();
    if (config && this.init) {
      this.init(config);
    }
    // if (config && this.init) {
    //   this.init(this.getCombinedConfig(config));

    //   // 拉取远程配置进行更新
    //   this.updateFromRemoteConfig(config);
    // }
  }
  var _proto = Shell.prototype;
  _proto.getCombinedConfig = function getCombinedConfig(config) {
    var combinedConf;
    if ((0, _combineConfig.isRemoteConfigEnable)(config) && (0, _is.isFunction)(this.getLocalConfig)) {
      var localConfig = this.getLocalConfig(0, config.pid);
      combinedConf = (0, _combineConfig["default"])(config, localConfig);
    }
    return combinedConf || config;
  };
  _proto.updateFromRemoteConfig = function updateFromRemoteConfig(config, reSetup) {
    if (reSetup === void 0) {
      reSetup = true;
    }
    // 请求动态配置
    if (config.pid && (0, _combineConfig.isRemoteConfigEnable)(config) && (0, _is.isFunction)(this.getRemoteConfig)) {
      var that = this;
      var proms = this.getRemoteConfig((0, _combineConfig.getRemoteConfigUrl)(config), config);
      proms === null || proms === void 0 ? void 0 : proms.then(function (remoteConfig) {
        if (!remoteConfig || remoteConfig.errorStatus !== undefined) return;
        var combinedConf = (0, _combineConfig["default"])(config, remoteConfig);

        // 无有效的新配置，无需更新
        if (!combinedConf) return;

        // 存储到本地
        if ((0, _is.isFunction)(that.storeRemoteConfig)) {
          that.storeRemoteConfig(remoteConfig, config.pid);
        }
        if (reSetup === false || config.remoteConfig.reSetup === false) return;
        var context = that.client.getContext();
        // 更新配置
        context.setConfig(combinedConf);
        // 逐个更新collector
        var collectors = that.client.getCollectors();
        collectors.forEach(function (collector) {
          if ((0, _is.isFunction)(collector.destroy)) {
            collector.destroy();
            collector.setup(context, that.client.sendEvent);
          }
        });
      });
    }
  }

  /**
   * 初始化
   */;
  _proto.sendEvent = function sendEvent(payload) {
    if (this.client) {
      this.client.sendEvent(payload);
    }
  }

  /**
   * get config
   */;
  _proto.getConfig = function getConfig() {
    if (this.client) {
      return this.client.getContext().getConfig();
    }
  }

  /**
   * 获取远程配置
   */;
  /**
   * 自定义事件上报
   */
  _proto.sendCustom = function sendCustom(payload) {
    if (!payload.name || !payload.type) {
      return;
    }
    var data = (0, _extends2["default"])({}, payload, {
      event_type: _rumEvent.RumEventType.CUSTOM
    });
    this.sendEvent(data);
  };
  /**
   * 自定义视图上报
   */
  _proto.sendView = function sendView(payload) {
    if (!(0, _is.isObject)(payload)) {
      return;
    }
    if (!payload.type) {
      payload.type = 'custom';
    }
    if (payload.type === 'custom') {
      var n = 0;
      ['t1', 't2', 't3'].forEach(function (key) {
        if (!(0, _is.isNumber)(payload[key])) {
          delete payload[key];
        }
        key in payload && n++;
      });
      if (n === 0) return;
    }
    var data = (0, _extends2["default"])({}, payload, {
      event_type: _rumEvent.RumEventType.VIEW
    });
    this.sendEvent(data);
  };
  /**
   * 自定义异常上报
   */
  _proto.sendException = function sendException(payload) {
    if (!payload.name || !payload.message) {
      return;
    }
    var name = payload.name,
      message = payload.message,
      stack = payload.stack;
    var data = (0, _extends2["default"])({
      times: 1,
      name: name,
      message: message,
      stack: stack
    }, payload, {
      event_type: _rumEvent.RumEventType.EXCEPTION,
      type: 'custom',
      source: 'custom'
    });
    this.sendEvent(data);
  };
  /**
   * 自定义资源上报
   */
  _proto.sendResource = function sendResource(payload) {
    if (!payload.name || !payload.type || !(0, _is.isNumber)(payload.duration)) {
      return;
    }
    var data = (0, _extends2["default"])({
      times: 1
    }, payload, {
      event_type: _rumEvent.RumEventType.RESOURCE
    });
    this.sendEvent(data);
  };
  return Shell;
}();